<!-- <div class="fixed-top">
  <div class="d-flex flex-column">
    <app-header #header></app-header>
    <app-breadcrumb></app-breadcrumb>
  </div>
</div> -->
<div id="backset" style="height:45px;"></div>
<!-- <nav aria-label="breadcrumb">
  <ol class="breadcrumb mb-0">
    <li class="breadcrumb-item active" style="cursor:pointer">MockUps</li>
  </ol>
</nav> -->
<h4 style="padding-top: 40px;">MockUps</h4>
<div class="mockups">
  <table>
    <thead>
      <tr>
        <th>Category</th>
        <th>Mockups</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let category of categories">
        <td>{{ category.name }}</td>
        <td>
          <ul>
            <li *ngFor="let item of category.items">
              <a (click)="openEmployee(item)"
                style="text-decoration: underline; cursor: pointer; color: blue;font-size: 20px;">{{ item }}</a>
            </li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</div>